import { CncEquipmentExt } from '../../../../shared/types/cncEquipmentExt.ts';
import { LinkButton } from '../../../components/linkButton.tsx';


interface Props {
    style: React.CSSProperties;
    equipments: CncEquipmentExt[];
    onEditClick: (equipment: CncEquipmentExt) => void;
}

export function CncCoordinatesTable({
    style,
    equipments,
    onEditClick,
}: Props) {
    return (
        <table style={style}>
            <thead>
                <tr>
                    <th>Equipment</th>
                    <th>Page</th>
                    <th>Column</th>
                    <th>Row</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {equipments?.map(equipment =>
                    <tr key={equipment.id}>
                        <td style={{ textAlign: 'left', paddingLeft: '30px' }}>
                            {equipment.displayName}
                        </td>
                        <td>{equipment.page}</td>
                        <td>{equipment.column}</td>
                        <td>{equipment.row}</td>
                        <td>
                            <LinkButton
                                onClick={() => onEditClick(equipment)}
                                content='Edit'
                            />
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
}
